
const router_modular = [
    {
        path: '/',
        name: 'login',
        component: () => import('@/views/home/LoginHome'),
        meta: {
            title: '赋米HRO雇员服务'
        }
    },
    {
        path: '/home',
        name: 'home',
        component: () => import('@/views/home/HomePage'),
        meta: {
            title: '首页'
        }
    },
    {
        path: '/home/IncomeDetai',
        name: 'IncomeDetai',
        component: () => import('@/views/components/IncomeDetai'),
        meta: {
            title: '佣金查询'
        }
    },
    {
        path: '/home/selectProject',
        name: 'selectProject',
        component: () => import('@/views/components/ProjectList'),
        meta: {
            title: '切换项目'
        }
    },
    {
        path: '/home/IncomeDetai/DealDetai',
        name: 'DealDetai',
        component: () => import('@/views/components/DealDetai'),
        meta: {
            title: '交易明细'
        }
    },
    {
        path: '/home/welfare',
        name: 'welfare',
        component: () => import('@/views/welfareMenu/insideIntroduce'),
        meta: {
            title: '内介专属通道'
        }
    }
]
export default router_modular